const $$splitComponentImporter = () => import('/build/web/src/routes/_authenticated/chat-records/sessions/$session_key.calls.$request_id.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
// v5 Epic E1 — L3a single-call detail.
// `/chat-records/sessions/:session_key/calls/:request_id`
//
// The canonical single-call entry under v5.  Replaces the legacy
// `/chat-records/records/:request_id` link generated by L2's call-list
// table (Epic E6).  The legacy route still resolves so existing
// bookmarks / external pasted URLs keep working.
//
// CallDetailBlock receives `expectedSessionKey` so a mismatched URL
// (e.g. wrong sk pasted next to a real request_id) surfaces an explicit
// "this call doesn't belong to that session" error instead of silently
// rendering content under the wrong sticky banner.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/stores/auth-store';
import { ROLE } from '@/lib/roles';
export const Route = createFileRoute('/_authenticated/chat-records/sessions/$session_key/calls/$request_id')({
  beforeLoad: () => {
    const auth = useAuthStore.getState().auth;
    if (!auth.user || auth.user.role < ROLE.ADMIN) {
      throw redirect({
        to: '/403'
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});